import script from "./CrudTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudTable.vue?vue&type=script&setup=true&lang=js"

import "./CrudTable.vue?vue&type=style&index=0&id=6478915e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6478915e"]])

export default __exports__